import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & { title?: string };

export const MenuIcon = ({ className, title, ...props }: Props) => (
  <svg
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
    role={title ? 'img' : 'presentation'}
    aria-hidden={title ? undefined : true}
    className={className ?? 'h-[17px] w-[17px]'}
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path d="M1.69724 4.883L14.6954 5.09915C14.9716 5.10375 15.1991 4.88366 15.2037 4.60754L15.2245 3.35771C15.2291 3.08159 15.009 2.85406 14.7329 2.84947L1.73465 2.63331C1.45853 2.62872 1.231 2.84881 1.2264 3.12493L1.20562 4.37476C1.20103 4.65088 1.42112 4.87841 1.69724 4.883ZM1.6141 9.88231L14.6123 10.0985C14.8884 10.1031 15.116 9.88296 15.1205 9.60685L15.1413 8.35702C15.1459 8.0809 14.9258 7.85337 14.6497 7.84877L1.65151 7.63262C1.3754 7.62803 1.14786 7.84812 1.14327 8.12424L1.12249 9.37407C1.11789 9.65018 1.33798 9.87772 1.6141 9.88231ZM1.53097 14.8816L14.5292 15.0978C14.8053 15.1024 15.0328 14.8823 15.0374 14.6062L15.0582 13.3563C15.0628 13.0802 14.8427 12.8527 14.5666 12.8481L1.56838 12.6319C1.29226 12.6273 1.06473 12.8474 1.06013 13.1235L1.03935 14.3734C1.03476 14.6495 1.25485 14.877 1.53097 14.8816Z" />
  </svg>
);

export default MenuIcon;
